import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../Contexts/UserContext';
import Sidebar from '../../components/sidebar/Sidebar';
import Navbar from '../navbar/Navbar';
import './kanban.scss';
import { useNavigate } from 'react-router-dom';
import { BiShowAlt } from 'react-icons/bi';

const statusColumns = [
    { title: 'Open', status: 'Open', backgroundColor: 'orange' },
    { title: 'In Progress', status: 'In Progress', backgroundColor: '#1d65ff' },
    { title: 'Resolved', status: 'Resolved', backgroundColor: 'rgb(0, 171, 46)' },
    { title: 'Closed', status: 'Closed', backgroundColor: 'rgb(245, 73, 73)' },
];

const KanbanBoard = () => {
    const { ticketData } = useContext(UserContext);
    console.log(ticketData);
    const navigate = useNavigate();

    return (
        <div className="container">
            <Sidebar />
            <div className="invoiceContainer">
                <Navbar />
                <div className="kanbanBoard">
                    {statusColumns.map((column) => (
                        <div key={column.status} className="kanbanColumn" style={{ backgroundColor: column.backgroundColor }}>
                            <h4>{column.title}</h4>
                            <div className="kanbanCards">
                                {ticketData
                                    ?.filter((ticket) => ticket.status === column.status)
                                    .map((ticket) => (
                                        <div key={ticket.id} className="kanbanCard">
                                            <div className="kanbanHeader">
                                                <p>{ticket.assignee.fullname}</p>
                                                <img src={ticket.assignee.img} className="assigneeImg" alt={ticket.assignee.fullname} />
                                            </div>
                                            <p>{ticket.subject}</p>
                                            <div className="kanbanCardBottom">
                                                <p>{ticket.timeStamp.toDate().toDateString()}</p>
                                                <button onClick={() => navigate(`/tickets/${ticket.id}`)}>View</button>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );

};

export default KanbanBoard;
